// import the template parts js
import * as tpModules0 from '../template-parts/header/main-nav/script.js'; import * as tpModules1 from '../template-parts/modules/content-aa_default/script.js'; import * as tpModules2 from '../template-parts/modules/content-all_posts_grid/script.js'; import * as tpModules3 from '../template-parts/modules/content-featured_posts_slider/script.js'; let tpModules = [tpModules0, tpModules1, tpModules2, tpModules3];
for (let tpModule of tpModules) {
    tpModule.default();
}


// WEBPACK FOOTER //
// ./js/app.js